import React from 'react';
import { useTranslation } from 'react-i18next';

/** Normalized list of non-empty skill path strings from a plan payload. */
export function normalizePlanSkills(skills) {
    if (!Array.isArray(skills)) return [];
    return skills.map((s) => String(s).trim()).filter(Boolean);
}

/**
 * Compact “used skills” block for priority cards (paths under skills/ without .md).
 */
export function PlanUsedSkillsTags({ skills, className = '' }) {
    const { t } = useTranslation('report-panels');
    const list = normalizePlanSkills(skills);

    if (list.length === 0) return null;

    return (
        <div className={className}>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400 mb-1.5">{t('usedSkills')}</p>
            <div className="flex flex-wrap gap-1">
                {list.map((s, idx) => (
                    <span
                        key={`${s}-${idx}`}
                        title={s}
                        className="inline-flex max-w-full truncate px-2 py-0.5 rounded-md text-[11px] font-mono bg-primary-50 text-primary-900 border border-primary-100"
                    >
                        {s}
                    </span>
                ))}
            </div>
        </div>
    );
}
